<ion-card class="hint keep-size ion-margin">
  <div class="ion-margin">
    <ion-icon *ngIf="!!icon" [src]="icon | srcAssets" class="xxl secondary-icon"></ion-icon>
    <p [innerHTML]="message | translate"></p>
  </div>
</ion-card>